
import { CSSProperties } from "@mui/material";

export const TableTheadStyle: CSSProperties = {
    backgroundColor: '#000',
    color: '#ffffff',
    textAlign: 'left',
}

export const TablePaddingStyle: CSSProperties = {
    padding: '12px 15px',
}

export const TableTbodyStyle: CSSProperties = {
    borderBottom: '1px solid #dddddd',
    backgroundColor: '#f5f5f5',
}
